import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import ChangePasswordDialog from '../ChangePasswordDialog';

const PAGE_META = {
  '/': { title: 'Executive Dashboard', subtitle: 'Real-time view of all partnership activity' },
  '/my-dashboard': { title: 'Team Dashboard', subtitle: 'Your assigned partnerships and KPI progress' },
  '/leaderboard': { title: 'Team Leaderboard', subtitle: 'Top performers across the team' },
  '/leads': { title: 'Partnership CRM', subtitle: 'Manage every partnership opportunity' },
  '/pipeline': { title: 'Sales Pipeline', subtitle: 'Drag deals through the stages' },
  '/sales': { title: 'Sales Dashboard', subtitle: 'Revenue, packages, commissions across partnerships' },
  '/resources': { title: 'Resource Center', subtitle: 'Quick-access internal & external resources' },
  '/assets': { title: 'Asset Tracker', subtitle: 'Internal resource & version management' },
  '/tasks': { title: 'Task Management', subtitle: 'What needs to get done' },
  '/calendar': { title: 'Calendar', subtitle: 'Meetings, podcasts, content deadlines' },
  '/analytics': { title: 'Partnership Analytics', subtitle: 'Revenue, closures, and conversion by partnership type' },
  '/reports': { title: 'Reports', subtitle: 'Export partnership performance data' },
  '/goals': { title: 'KPI Goal Center', subtitle: 'Set monthly, quarterly, and annual targets' },
  '/member-goals': { title: 'Per-Member KPI Goals', subtitle: 'Set individual goals by partnership type' },
  '/audit-log': { title: 'Audit Log', subtitle: 'Complete activity history across the platform' },
  '/settings': { title: 'Admin Settings', subtitle: 'Team and platform administration' },
  '/account': { title: 'My Account', subtitle: 'Password, notification preferences, calendar export' },
  '/booking': { title: 'Book with Me', subtitle: 'Your public scheduling link and availability' },
  '/communications': { title: 'Communications', subtitle: 'Email campaigns, subscribers & templates' },
};

export function AppLayout() {
  const loc = useLocation();
  const { user } = useAuth();
  const meta = PAGE_META[loc.pathname] || { title: 'AAWTA Partnership Hub' };
  const forceChange = !!user?.must_change_password;

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Sidebar />
      <div className="md:ml-72">
        <Topbar title={meta.title} subtitle={meta.subtitle} />
        <main className="p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
      {forceChange && <ChangePasswordDialog open={true} onOpenChange={() => {}} forced={true} />}
    </div>
  );
}
